'use strict';
import angular from 'angular';
import _ from 'lodash';
import slotFormHtmlUrl from '../views/slotForm.html';
import slotMappingFormHtmlUrl from '../views/slotMappingForm.html';
import slotTypeFormHtmlUrl from '../views/slotTypeForm.html';

angular.module('calendar.ctrls', [])
    .controller('SlotsController', ['$scope', '$modal', '$ioAlert', '$confirm', '$state', '$rootScope', 'CalendarService', 'ClusterService', 'FormService', function($scope, $modal, $ioAlert, $confirm, $state, $rs, CalendarService, ClusterService, FormService) {
        $scope.slots = [];
        $scope.websites = [];
        $scope.sections = [];
        $scope.slotTypes = [];
        $scope.sortReverse = false;
        $scope.sortType = 'name';
        $scope.disableBtnAction = false;

        $scope.data = false;

        $scope.weekList = [
            { id: "All", label: "Everyday", selected: false, disabled: false, isDay: false },
            { id: "Work", label: "Weekdays", selected: false, disabled: false, isDay: false },
            { id: 0, label: "Sunday", selected: false, disabled: false, isDay: true },
            { id: 1, label: "Monday", selected: false, disabled: false, isDay: true },
            { id: 2, label: "Tuesday", selected: false, disabled: false, isDay: true },
            { id: 3, label: "Wednesday", selected: false, disabled: false, isDay: true },
            { id: 4, label: "Thursday", selected: false, disabled: false, isDay: true },
            { id: 5, label: "Friday", selected: false, disabled: false, isDay: true },
            { id: 6, label: "Saturday", selected: false, disabled: false, isDay: true }
        ];
        $scope.weekNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        //$scope.slot = {};

        $scope.gotoSlotTypes = function() {
            $state.go('calendarSlotTypes');
        }

        $scope.weekSelect = function(day) {
            if (day.disabled) return false;
            day.selected = !day.selected;
            var dayIndex = $scope.weekList.indexOf(day);
            var disabledVal = false;
            var isDaySelected = false;
            if ((day.id == "All" || day.id == "Work") && day.selected) {
                disabledVal = true;
            }
            for (var i in $scope.weekList) {
                if ($scope.weekList[i].id != "All" && $scope.weekList[i].id != "Work") {
                    $scope.weekList[i].disabled = disabledVal;
                }
                if ($scope.weekList[i].isDay && $scope.weekList[i].selected) {
                    isDaySelected = true;
                }
            }
            if (isDaySelected) {
                $scope.weekList[0].disabled = true;
                $scope.weekList[1].disabled = true;
            } else {
                $scope.weekList[0].disabled = false;
                $scope.weekList[1].disabled = false;
            }
            if (day.id == "All" && day.selected) {
                $scope.weekList[0].selected = true;
                $scope.weekList[1].selected = false;
            } else if (day.id == "Work" && day.selected) {
                $scope.weekList[0].selected = false;
                $scope.weekList[1].selected = true;
            }
        }

        $scope.getWebsites = function() {
            CalendarService.getWebsites({ clusterId: ClusterService.clusterIds }).then(function(success) {
                $scope.websites = success.websitePlacements;
                $scope.resetWebsitesSelect();
            }, function(error) {
                $ioAlert.show('Error!', 'Could not retrieve websites.', 'error');
                $rs.loadingInProgress = false;
            });
        }

        $scope.getSections = function() {

            $rs.loadingInProgress = true;
            $rs.loadertitle = "Fetching Slots";
            CalendarService.getSections({ clusterId: ClusterService.clusterIds }).then(function(success) {
                $scope.sections = success.websiteSections;

                $scope.resetSectionsSelect();
            }, function(error) {
                $ioAlert.show('Error!', 'Could not retrieve sections.', 'error');
                $rs.loadingInProgress = false;
            });
        }

        $scope.getSlotTypes = function() {
            CalendarService.getSlotTypes().then(function(success) {
                $scope.slotTypes = success.slotTypes;
                $scope.resetSlotTypesSelect();
            }, function(error) {
                $ioAlert.show('Error!', 'Could not retrieve slot types.', 'error');
                $rs.loadingInProgress = false;
            });
        }

        $scope.resetWebsitesSelect = function() {
            for (var i = 0, len = $scope.websites.length; i < len; i++) {
                $scope.websites[i].selected = false;
            }
        }

        $scope.resetSectionsSelect = function() {
            for (var i = 0, len = $scope.sections.length; i < len; i++) {
                $scope.sections[i].selected = false;
            }
        }

        $scope.resetSlotTypesSelect = function() {
            for (var i = 0, len = $scope.slotTypes.length; i < len; i++) {
                $scope.slotTypes[i].selected = false;
            }
        }

        $scope.resetWeekDays = function() {
            _.each($scope.weekList, function(day) {
                day.selected = false;
            })
        }

        $scope.resetForm = function() {
            $scope.resetWebsitesSelect();
            $scope.resetSectionsSelect();
            $scope.resetSlotTypesSelect();
            $scope.resetWeekDays();
        }

        $scope.getSlots = function() {
            CalendarService.getSlots({ clusterId: ClusterService.clusterIds }).then(function(data) {
                $scope.slots = data;

                for (var i = 0, len = $scope.slots.length; i < len; i++) {
                    for (var j = 0, jlen = $scope.slots[i].sections.length; j < jlen; j++) {
                        var section = $scope.slots[i].sections[j];
                        for (var k = 0, klen = section.slotTypes.length; k < klen; k++) {
                            $scope.slots[i].sections[j].slotTypes[k].days_of_week_name = null;
                            var slotType = section.slotTypes[k];
                            if (section.days_of_week) {
                                if (slotType.days_of_week.length == 7) {
                                    $scope.slots[i].sections[j].slotTypes[k].days_of_week_name = "Everyday";
                                } else if (slotType.days_of_week.length == 5 && slotType.days_of_week.indexOf(0) === -1 && slotType.days_of_week.indexOf(6) === -1) {
                                    $scope.slots[i].sections[j].slotTypes[k].days_of_week_name = "Weekdays";
                                }
                            }
                        }
                    }
                }
                $scope.showdata = true;
                $rs.loadingInProgress = false;
            }, function(error) {
                $ioAlert.show('Error!', 'Could not retrieve slots.', 'error');
                $rs.loadingInProgress = false;
            });
        }

        $scope.addSlot = function() {
            var slots = [];
            $scope.daysOfWeek = [];
            var slotCnt = 0;
            for (var i = 0, len = $scope.websites.length; i < len; i++) {
                if ($scope.websites[i].selected) {
                    var slot = {};
                    slot.website_id = $scope.websites[i].id;
                    slot.website_name = $scope.websites[i].name;
                    slot.sections = [];
                    for (var j = 0, jlen = $scope.sections.length; j < jlen; j++) {
                        if ($scope.sections[j].selected) {
                            var section = $scope.sections[j];
                            section.slotTypes = getSelectedSlotTypes();
                            slot.sections.push(section);
                        }
                    }
                    slots.push(slot);
                }
            }
            for (var i = 0, len = $scope.weekList.length; i < len; i++) {
                if ($scope.weekList[i].selected === true) {
                    if ($scope.weekList[i].id == "All") {
                        $scope.daysOfWeek = [0, 1, 2, 3, 4, 5, 6];
                        break;
                    } else if ($scope.weekList[i].id == "Work") {
                        $scope.daysOfWeek = [1, 2, 3, 4, 5];
                        break;
                    } else {
                        $scope.daysOfWeek.push($scope.weekList[i].id);
                    }
                }
            }
            CalendarService.addSlots({ websites: slots, daysOfWeek: $scope.daysOfWeek }).then(function(data) {
                $scope.resetForm();
                $scope.getSlots();
                $ioAlert.show('New Slot', 'New Slots has been added successfully', 'success');
            });
        };

        $scope.editSlot = function(slot) {
            $modal.open({
                controller: function($scope, $modalInstance, slot, data, CalendarService, $ioAlert) {
                    $scope.slotObj = {};
                    $scope.sections = angular.copy(data.sections);
                    $scope.slotTypes = angular.copy(data.slotTypes);
                    $scope.slotObj = angular.copy(slot);
                    $scope.section = {};
                    $scope.sectionSelected = false;
                    $scope.weekList = angular.copy(data.weekList);
                    $scope.weekSelected = false;

                    $scope.weekSelect = function(day) {
                        if (day.disabled) return false;
                        day.selected = !day.selected;
                        var dayIndex = $scope.weekList.indexOf(day);
                        var disabledVal = false;
                        var isDaySelected = false;
                        if ((day.id == "All" || day.id == "Work") && day.selected) {
                            disabledVal = true;
                        }
                        for (var i in $scope.weekList) {
                            if ($scope.weekList[i].id != "All" && $scope.weekList[i].id != "Work") {
                                $scope.weekList[i].disabled = disabledVal;
                            }
                            if ($scope.weekList[i].isDay && $scope.weekList[i].selected) {
                                isDaySelected = true;
                            }
                        }
                        if (isDaySelected && !disabledVal) {
                            $scope.weekList[0].disabled = true;
                            $scope.weekList[1].disabled = true;
                            $scope.weekList[0].selected = false;
                            $scope.weekList[1].selected = false;
                        } else {
                            $scope.weekList[0].disabled = false;
                            $scope.weekList[1].disabled = false;
                        }
                        if (day.id == "All" && day.selected) {
                            $scope.weekList[0].selected = true;
                            $scope.weekList[1].selected = false;
                        } else if (day.id == "Work" && day.selected) {
                            $scope.weekList[0].selected = false;
                            $scope.weekList[1].selected = true;
                        }
                        var slotId;
                        _.each($scope.slotTypes, function(slot) {
                            if (slot.selected && slot.show) {
                                slotId = slot.id;
                            }
                        })

                        _.each($scope.slotObj.sections, function(section) {
                            if (section.id == $scope.section.id) {
                                _.each(section.slotTypes, function(slot) {
                                    if (slot.id == slotId) {
                                        slot.days_of_week = [];
                                        if ($scope.weekList[0].selected === true) {
                                            slot.days_of_week = [0, 1, 2, 3, 4, 5, 6];
                                        } else if ($scope.weekList[1].selected === true) {
                                            slot.days_of_week = [1, 2, 3, 4, 5];
                                        } else {
                                            _.each($scope.weekList, function(week) {
                                                if (week.selected === true) {
                                                    slot.days_of_week.push(week.id);
                                                }
                                            });
                                        }
                                    }
                                });
                            }
                        });
                    }

                    $scope.saveSlot = function(slotForm) {
                        if (slotForm.$valid) {
                            var bkSections = angular.copy($scope.slotObj.sections);
                            $scope.slotObj.sections = [];
                            for (var i = 0, ilen = $scope.sections.length; i < ilen; i++) {
                                if ($scope.sections[i].selected === true) {
                                    for (var k = 0, klen = bkSections.length; k < klen; k++) {
                                        if (bkSections[k].id == $scope.sections[i].id) {
                                            $scope.slotObj.sections.push(bkSections[k]);
                                            break;
                                        }
                                    }
                                }
                            }
                            var saveSlotObj = {
                                website_id: $scope.slotObj.website_id,
                                "sections": angular.toJson($scope.slotObj.sections)
                            }

                            CalendarService.updateSlot(saveSlotObj).then(function(response) {
                                if (response.errors) {
                                    for (var i = 0, len = response.errors.length; i < len; i++) {
                                        $ioAlert.show('Error', response.errors[i]);
                                    }
                                }
                                $modalInstance.close(response);
                            }, function(error) {
                                console.log("Error updating slot");
                            });
                        }
                    }

                    $scope.cancel = function() {
                        $modalInstance.dismiss();
                    }

                    var setWeekSelect = function(slotObj) {
                        $scope.resetDays();
                        $scope.weekSelected = true;
                        if (!slotObj.days_of_week) {
                            slotObj.days_of_week = [];
                        }
                        if (slotObj.days_of_week.length == 7) {
                            $scope.weekList[0].selected = true;
                        } else if (slotObj.days_of_week.length == 5 && slotObj.days_of_week.indexOf(0) === -1 && slotObj.days_of_week.indexOf(6) === -1) {
                            $scope.weekList[1].selected = true;
                        } else {
                            _.each(slotObj.days_of_week, function(day) {
                                _.each($scope.weekList, function(weekday) {
                                    if (weekday.id == day) {
                                        weekday.selected = true;
                                    }
                                });
                            });
                        }

                    }

                    $scope.showSectionSlotTypes = function(section) {
                        if (section.selected && section.show !== true) {
                            $scope.section = section;
                            $scope.sectionSelected = true;
                            for (var i = 0, ilen = $scope.sections.length; i < ilen; i++) {
                                $scope.sections[i].show = false;
                            }
                            _.each($scope.slotObj.sections, function(section) {
                                section.show = false;
                            });
                            $scope.resetSlotTypesSelect();
                            $scope.resetDays();
                            section.show = true;
                            for (var j = 0, jlen = $scope.slotObj.sections.length; j < jlen; j++) {
                                if ($scope.slotObj.sections[j].id == section.id) {
                                    $scope.slotObj.sections[j].show = true;
                                    var sectionObj = $scope.slotObj.sections[j];
                                    if (sectionObj.slotTypes) {
                                        for (var k = 0, klen = sectionObj.slotTypes.length; k < klen; k++) {
                                            $scope.setSlotTypeSelect(sectionObj.slotTypes[k]);
                                        }
                                    }
                                    break;
                                }
                            }

                        } else {
                            section.show = false;
                            for (var i = 0, ilen = $scope.sections.length; i < ilen; i++) {
                                $scope.sections[i].show = false;
                            }
                            $scope.section = {};
                            $scope.sectionSelected = false;
                            $scope.resetSlotTypesSelect();
                            $scope.resetDays();
                        }
                    }

                    $scope.setSection = function(section, event) {
                        event.stopPropagation();
                        if (section.selected === true) {
                            $scope.resetSlotTypesSelect();
                            for (var j = 0, jlen = $scope.sections.length; j < jlen; j++) {
                                if ($scope.sections[j].selected === true) {
                                    var haveSection = false;
                                    for (var k = 0, klen = $scope.slotObj.sections.length; k < klen; k++) {
                                        if ($scope.slotObj.sections[k].id == $scope.sections[j].id) {
                                            haveSection = true;
                                            break;
                                        }
                                    }
                                    if (haveSection === false) {
                                        $scope.slotObj.sections.push($scope.sections[j]);
                                    }
                                }
                            }
                            $scope.showSectionSlotTypes(section);
                        } else {
                            for (var i = 0, ilen = $scope.sections.length; i < ilen; i++) {
                                $scope.sections[i].show = false;
                            }
                            _.each($scope.slotObj.sections, function(s) {
                                if (s.id == section.id) {
                                    s.slotTypes = [];
                                }
                            });

                            $scope.section = {};
                            $scope.sectionSelected = false;
                            $scope.weekSelected = false;
                            $scope.resetSlotTypesSelect();
                            $scope.resetDays();
                        }
                    }

                    $scope.setSectionSlotType = function(slotType, event) {
                        event.stopPropagation();
                        $scope.weekSelected = false;
                        $scope.resetDays();
                        if ($scope.sectionSelected === true) {
                            var sectionIndex;
                            _.each($scope.slotObj.sections, function(section, index) {
                                if (section.selected && section.show) {
                                    sectionIndex = index;
                                }
                            });
                            var sectionObj = $scope.slotObj.sections[sectionIndex];
                            if (slotType.selected == true) {
                                _.each($scope.slotTypes, function(slot) {
                                    slot.show = false;
                                    if (slot.id == slotType.id) {
                                        slot.show = true;
                                    }
                                });
                                var haveSlot = false;

                                _.each(sectionObj.slotTypes, function(slot) {
                                    if (slot.id == slotType.id) {
                                        haveSlot = true;
                                    }
                                });
                                if (haveSlot == false) {
                                    $scope.weekSelected = true;
                                    if (!$scope.slotObj.sections[sectionIndex].slotTypes) {
                                        $scope.slotObj.sections[sectionIndex].slotTypes = [];
                                    }
                                    $scope.slotObj.sections[sectionIndex].slotTypes.push(slotType)
                                }
                            } else {
                                _.each($scope.slotTypes, function(slot) {
                                    slot.show = false;
                                });
                                _.remove(sectionObj.slotTypes, function(slot) {
                                    return slot.id == slotType.id;
                                });
                                console.log(sectionObj);
                                console.log($scope.slotObj.sections);
                            }
                        }
                    }

                    $scope.showSlotType = function(slotType) {
                        _.each($scope.slotTypes, function(slot) {
                            slot.show = false;
                        });
                        if (slotType.selected && slotType.show !== true) {
                            slotType.show = true;
                            _.each($scope.slotObj.sections, function(section) {
                                _.each(section.slotTypes, function(slot) {
                                    if (slot.id == slotType.id) {
                                        setWeekSelect(slot);
                                    }
                                })
                            })

                        }

                    }

                    $scope.resetSectionsSelect = function() {
                        for (var i = 0, len = $scope.sections.length; i < len; i++) {
                            $scope.sections[i].selected = false;
                            $scope.sections[i].show = false;
                        }
                    }

                    $scope.resetSlotTypesSelect = function() {
                        for (var i = 0, len = $scope.slotTypes.length; i < len; i++) {
                            $scope.slotTypes[i].selected = false;
                            $scope.slotTypes[i].show = false;
                        }
                    }

                    $scope.resetDays = function() {
                        _.each($scope.weekList, function(day) {
                            day.selected = false;
                            day.disabled = false;
                        })
                    }

                    $scope.setSectionSelect = function(section) {
                        for (var j = 0, jlen = $scope.sections.length; j < jlen; j++) {
                            if ($scope.sections[j].id == section.id) {
                                $scope.sections[j].selected = true;
                                break;
                            }
                        }
                    }

                    $scope.setSlotTypeSelect = function(slotType) {
                        for (var k = 0, klen = $scope.slotTypes.length; k < klen; k++) {
                            if ($scope.slotTypes[k].id == slotType.id) {
                                $scope.slotTypes[k].selected = true;
                                break;
                            }
                        }
                    }

                    $scope.init = function() {
                        $scope.resetSectionsSelect();
                        $scope.resetSlotTypesSelect();
                        $scope.resetDays();
                        for (var j = 0, len = $scope.slotObj.sections.length; j < len; j++) {
                            var section = $scope.slotObj.sections[j];
                            $scope.setSectionSelect(section);
                            /*for(var k=0, klen = section.slotTypes.length; k < klen; k++){
                                $scope.setSlotTypeSelect(section.slotTypes[k]);
                            }*/
                        }
                    }
                    $scope.init();

                },
                templateUrl: slotFormHtmlUrl,
                resolve: {
                    slot: function() {
                        return slot;
                    },
                    data: function() {
                        return {
                            sections: $scope.sections,
                            slotTypes: $scope.slotTypes,
                            weekList: $scope.weekList
                        }
                    }
                },
                backdrop: 'static',
                size: 'md'
            }).result.then(function(slotObj) {
                $scope.getSlots();
                //$scope.slots[$scope.slots.indexOf(slotObj)] = slotObj;
                $ioAlert.show('Update Slot', 'Slot has been updated successfully', 'success');
            }, function(cancel) {

            });
        }

        $scope.delSlot = function(slot) {
            $confirm.open({
                size: 'sm',
                text: 'Are you sure you want to delete this Slot?'
            }).then(function() {
                CalendarService.deleteSlot({ id: slot.website_id }).then(function(response) {
                    if (response.errors) {
                        for (var i = 0, len = response.errors.length; i < len; i++) {
                            $ioAlert.show('Error', response.errors[i]);
                        }
                    } else {
                        $scope.resetForm();
                        $scope.getSlots();
                        $ioAlert.show('Slot Deleted', 'Slot has been deleted successfully', 'success');
                    }
                }, function(error) {
                    $ioAlert.show('Error!', 'Could not delete slot.', 'error');
                });
            });
        }

        function getSelectedSlotTypes() {
            var selectedSlotTypes = [];
            for (var k = 0, klen = $scope.slotTypes.length; k < klen; k++) {
                if ($scope.slotTypes[k].selected) {
                    selectedSlotTypes.push($scope.slotTypes[k]);
                }
            }
            return selectedSlotTypes;
        }

        function setWebsiteSelect(slot) {
            for (var i = 0, len = $scope.websites.length; i < len; i++) {
                if ($scope.websites[i].id == slot.website_id) {
                    $scope.websites[i].selected = true;
                    break;
                }
            }
        }

        function setSectionSelect(section) {
            for (var j = 0, jlen = $scope.sections.length; j < jlen; j++) {
                if ($scope.sections[j].id == section.id) {
                    $scope.sections[j].selected = true;
                    break;
                }
            }
        }

        function setSlotTypeSelect(slotType) {
            for (var k = 0, klen = $scope.slotTypes.length; k < klen; k++) {
                if ($scope.slotTypes[k].id == slotType.id) {
                    $scope.slotTypes[k].selected = true;
                    break;
                }
            }
        }

        var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
            //$scope.getSlotTypes();
            $scope.getSections();
            $scope.getWebsites();
            $scope.getSlots();

        });

        $scope.$on('$destroy', function() {
            clusterSelector();
        });

        /*
        * Handle get instance lock configuration
        */
        var getInstanceLockConfig = function() {
            FormService.getInstanceLockConfig().then(function(data) {
                if(data.instanceLocked) {
                    $scope.disableBtnAction = true;
                } else {
                    $scope.disableBtnAction = false;
                }

            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }

        var init = function() {
            ClusterService.initCluster($rs.userRole, 'singleSelect').then(function() {
                $scope.getSlotTypes();
                $scope.getSections();
                $scope.getWebsites();
                $scope.getSlots();
                getInstanceLockConfig();
            });
        };
        init();
    }])
    .controller('SlotTypeController', ['$scope', '$rootScope', '$modal', '$ioAlert', '$confirm', '$state', 'CalendarService', 'filterFilter', function($scope, $rs, $modal, $ioAlert, $confirm, $state, CalendarService, filterFilter) {
        $scope.slotTypes = [];
        $scope.getSlotTypes = function() {
            $rs.loadingInProgress = true;
            $rs.loadertitle = "Fetching Slot Types";
            CalendarService.getSlotTypes().then(function(success) {
                $scope.slotTypes = success.slotTypes;

                //set the ids as numbers instead of strings for proper sorting
                if ($scope.slotTypes.length > 0) {
                    for (var i = 0, len = $scope.slotTypes.length; i < len; i++) {
                        $scope.slotTypes[i].id = parseInt($scope.slotTypes[i].id);
                    }
                }
                $rs.loadingInProgress = false;
            }, function(error) {
                $rs.loadingInProgress = false;
                $ioAlert.show('Error!', 'Could not retrieve slot types.', 'error');
            });
        }

        // search based on user text
        $scope.updateSearch = function() {
            if ($scope.searchSlotTypes) {
                $scope.filteredSlotTypes = filterFilter($scope.slotTypes, $scope.searchSlotTypes);
            }
        };

        $scope.addSlotType = function() {
            $scope.viewSlotType();
        }

        $scope.editSlotType = function(slotType) {
            $scope.viewSlotType(slotType);
        }

        $scope.viewSlotType = function(slotType) {
            $scope.isNew = (slotType == null);
            $modal.open({
                controller: function($scope, $modalInstance, slotType, CalendarService, $ioAlert) {
                    $scope.slotTypeObj = {};
                    if (slotType) {
                        $scope.slotTypeObj.id = slotType.id;
                        $scope.slotTypeObj.name = slotType.name;
                        $scope.titleText = "Update";
                    } else {
                        $scope.titleText = "Create New";
                    }
                    $scope.save = function(slotTypeForm) {
                        if (slotTypeForm.$valid) {
                            if (slotType) {
                                CalendarService.updateSlotType($scope.slotTypeObj).then(function(response) {
                                    if (response.errors) {
                                        for (var i = 0, len = response.errors.length; i < len; i++) {
                                            $ioAlert.show('Error', response.errors[i]);
                                        }
                                    }
                                    if (response.slotType) {
                                        $modalInstance.close(response.slotType);
                                    }
                                }, function(error) {
                                    console.log("Error Update Slot Type");
                                });
                            } else {
                                CalendarService.addSlotType($scope.slotTypeObj).then(function(response) {
                                    if (response.errors) {
                                        for (var i = 0, len = response.errors.length; i < len; i++) {
                                            $ioAlert.show('Error', response.errors[i]);
                                        }
                                    }
                                    if (response.slotType) {
                                        $modalInstance.close(response.slotType);
                                    }
                                }, function(error) {
                                    console.log("Error Adding Slot Type");
                                });
                            }
                        }
                    };
                    $scope.cancel = function() {
                        $modalInstance.dismiss();
                    }
                },
                templateUrl: slotTypeFormHtmlUrl,
                resolve: {
                    slotType: function() {
                        return slotType;
                    }
                },
                backdrop: 'static'
            }).result.then(function(slotTypeObj) {
                if ($scope.isNew) {
                    $scope.slotTypes.push(slotTypeObj);
                    $ioAlert.show('New Slot Type', 'New Slot Type has been added successfully', 'success');
                } else {
                    $scope.slotTypes[$scope.slotTypes.indexOf(slotType)] = slotTypeObj;
                    $ioAlert.show('Update Slot Type', 'Slot Type has been updated successfully', 'success');
                }
            }, function(cancel) {

            });
        }

        $scope.deleteSlotType = function(slotType) {
            var index = $scope.slotTypes.indexOf(slotType);
            $confirm.open({
                size: 'sm',
                text: 'Are you sure you want to delete this Slot Type?'
            }).then(function() {
                CalendarService.deleteSlotType(slotType).then(function(response) {
                    if (response.errors) {
                        for (var i = 0, len = response.errors.length; i < len; i++) {
                            $ioAlert.show('ERROR!', response.errors[i], 'error');
                        }
                    } else {
                        $ioAlert.show('Slot Type Deleted', 'Slot Type has been deleted successfully', 'success');
                        $scope.slotTypes.splice(index, 1);
                    }
                });
            });
        }

        $scope.gotoSlotMappingsBySlotType = function(slotType) {
            $state.go('calendarSlotMappingsBySlotType', {
                slotTypeId: slotType.id
            });
        }

        var init = function() {
            $scope.getSlotTypes();
        };
        init();
    }])
    .controller('SlotMappingController', ['$scope', '$modal', '$ioAlert', '$confirm', '$state', '$stateParams', '$rootScope', 'CalendarService', 'ClusterService', function($scope, $modal, $ioAlert, $confirm, $state, $stateParams, $rs, CalendarService, ClusterService) {
        $scope.slotTypeId = $stateParams.slotTypeId;
        $scope.slotMappings = [];
        $scope.slotTypes = [];
        $scope.adSizes = [];
        $scope.slotType = [];

        $scope.getAdSizes = function() {
            $rs.loadingInProgress = true;
            $rs.loadertitle = "Fetching Slot Mappings";
            CalendarService.getAdSizes({ clusterId: ClusterService.clusterIds[0] }).then(function(success) {
                $scope.adSizes = success.adSizes;
                $scope.getSlotTypes();
            }, function(error) {
                $ioAlert.show('Error!', 'Could not retrieve ad sizes.', 'error');
            });
        }

        /*
         * Get the lookup types
         */
        var getLookupTypes = function() {
            CalendarService.getLookupTypes().then(function(response) {
                $scope.lookupTypes = response.lookupTypes;
            }, function(error) {
                $ioAlert.show('Error!', 'Could not retrieve lookup types.', 'error');
            });
        }

        $scope.getSlotTypes = function() {
            CalendarService.getSlotTypes().then(function(success) {
                $scope.slotTypes = success.slotTypes;
                var slotTypeObj = _.find($scope.slotTypes, { id: $scope.slotTypeId });
                if (slotTypeObj) {
                    $scope.slotType = slotTypeObj;
                }
                CalendarService.getSlotMappingsForSlotType({ slotTypeId: $scope.slotTypeId }).then(function(success) {
                    $scope.slotMappings = success.slotMappings;
                    if ($scope.slotMappings.length > 0) {
                        for (var i = 0, len = $scope.slotMappings.length; i < len; i++) {
                            $scope.slotMappings[i].slot_type_name = "";
                            var slotTypeObj = _.find($scope.slotTypes, { id: $scope.slotMappings[i].slot_type_id });
                            if (slotTypeObj) {
                                $scope.slotMappings[i].slot_type_name = slotTypeObj.name;
                            }
                        }
                    }
                    $rs.loadingInProgress = false;
                }, function(error) {
                    $ioAlert.show('Error!', 'Could not retrieve slot mappings.', 'error');
                    $rs.loadingInProgress = false;
                });
            }, function(error) {
                $ioAlert.show('Error!', 'Could not retrieve slot types.', 'error');
                $rs.loadingInProgress = false;
            });
        }

        $scope.addSlotMapping = function() {
            $scope.viewSlotMapping();
        }

        $scope.editSlotMapping = function(slotMapping) {
            $scope.viewSlotMapping(slotMapping);
        }

        $scope.viewSlotMapping = function(slotMapping) {
            $scope.isNew = (slotMapping == null);
            $modal.open({
                controller: function($scope, $modalInstance, slotMapping, slotType, slotTypeId, lookupTypes, clusterId, CalendarService, $ioAlert) {
                    $scope.slotMappingObj = {};
                    $scope.slotType = slotType;
                    $scope.adSizes = [];
                    $scope.lookupTypes = lookupTypes;
                    $scope.lookupContents = [];

                    /*
                     * Fetch the lookup content based on lookup type
                     */
                    $scope.lookupTypeChanged = function(lookupTypeId, isEdit) {
                        $scope.lookupContents = [];
                        CalendarService.getLookupContents({ lookupTypeId: lookupTypeId, clusterId: clusterId }).then(function(response) {
                            $scope.lookupContents = response.lookupContents;
                            if (isEdit) {
                                $scope.slotMappingObj.adSizeId = slotMapping.ad_size_id;
                            }
                        }, function(error) {
                            $ioAlert.show('Error!', 'Could not retrieve lookup contents.', 'error');
                        });
                    }


                    if (slotMapping) {
                        $scope.slotMappingObj.id = slotMapping.id;
                        $scope.slotMappingObj.slotTypeId = slotMapping.slot_type_id;
                        $scope.titleText = "Update";
                        $scope.lookupTypeId = slotMapping.lookup_type_id;
                        $scope.lookupTypeChanged(slotMapping.lookup_type_id, true);
                    } else {
                        $scope.titleText = "Create New";
                        $scope.slotMappingObj.slotTypeId = slotTypeId;
                    }

                    $scope.save = function(slotMappingForm) {
                        if (slotMappingForm.$valid) {
                            if (slotMapping) {
                                CalendarService.updateSlotMapping($scope.slotMappingObj).then(function(response) {
                                    if (response.errors) {
                                        for (var i = 0, len = response.errors.length; i < len; i++) {
                                            $ioAlert.show('Error', response.errors[i]);
                                        }
                                    }
                                    if (response.slotMapping) {
                                        $modalInstance.close(response.slotMapping);
                                    }
                                }, function(error) {
                                    console.log("Error Update Slot Mapping");
                                });
                            } else {
                                CalendarService.addSlotMapping($scope.slotMappingObj).then(function(response) {
                                    if (response.errors) {
                                        for (var i = 0, len = response.errors.length; i < len; i++) {
                                            $ioAlert.show('Error', response.errors[i]);
                                        }
                                    }
                                    if (response.slotMapping) {
                                        $modalInstance.close(response.slotMapping);
                                    }
                                }, function(error) {
                                    console.log("Error Adding Slot Mapping");
                                });
                            }
                        } else {
                            console.log($scope.slotMappingObj)
                            $ioAlert.show('Error', "Please fill the required fields");

                        }
                    };

                    $scope.cancel = function() {
                        $modalInstance.dismiss();
                    }
                },
                templateUrl: slotMappingFormHtmlUrl,
                resolve: {
                    slotMapping: function() {
                        return slotMapping;
                    },
                    slotType: function() {
                        return $scope.slotType;
                    },
                    slotTypeId: function() {
                        return $scope.slotTypeId;
                    },
                    lookupTypes: function() {
                        return $scope.lookupTypes;
                    },
                    clusterId: function(){
                        return ClusterService.clusterIds[0];
                    }
                },
                backdrop: 'static'
            }).result.then(function(slotMappingObj) {
                $rs.loadingInProgress = true;
                $rs.loadertitle = "Fetching Slot Mappings";
                $scope.getSlotTypes();
                if ($scope.isNew) {
                    $ioAlert.show('New Slot Mapping', 'New Slot Mapping has been added successfully', 'success');
                } else {
                    $ioAlert.show('Update Slot Mapping', 'Slot Mapping has been updated successfully', 'success');
                }
            }, function(cancel) {

            });
        }

        $scope.deleteSlotMapping = function(slotMapping) {
            var index = $scope.slotMappings.indexOf(slotMapping);
            $confirm.open({
                size: 'sm',
                text: 'Are you sure you want to delete this Slot Mapping?'
            }).then(function() {
                CalendarService.deleteSlotMapping(slotMapping).then(function(response) {
                    if (response.errors) {
                        for (var i = 0, len = response.errors.length; i < len; i++) {
                            $ioAlert.show('ERROR!', response.errors[i], 'error');
                        }
                    } else {
                        $ioAlert.show('Slot Mapping Deleted', 'Slot Mapping has been deleted successfully', 'success');
                        $scope.slotMappings.splice(index, 1);
                    }
                });
            });
        }

        $scope.gotoSlotTypes = function() {
            $state.go('calendarSlotTypes');
        }

        var init = function() {
            ClusterService.initCluster($rs.userRole, 'singleSelect').then(function() {
                $scope.getAdSizes();
                getLookupTypes();
            });
        };
        init();
    }]);